export default {
  // DSM
  white: '#fff',
  secondary: '#0000ff',
  onyx: '#373741',
  onyx80: '#5f5f67',
  onyx60: '#87878d',
  onyx40: '#afafb3',
  onyx20: '#d7d7d9',
  platinum: '#ebebeb',
  platinum20: '#E2E2E3',
  platinum40: '#f3f3f3',
  platinum60: '#f7f7f7',
  platinum80: '#fbfbfb',

  // Shell Specific
  shellRed: '#dd0021',
  yellow: '#fbce07',

  // Application
  error: '#db4052',
  primary: '#1c73ff',
  success: '#66b58e',
  info: '#005fbf',
  warning: '#ff9400',
  remove: '#ff5951',
  background: '#f6f8fa',
  loadingProviderBackground: 'rgba(0,0,0,0.667)',
  defaultBrowserOutlineBlue: '#3b99fc',
  disable: '#939090',

  // Marianne (new - figma)
  fontBody: '#303641',
  austin: '#7c7c94',
  sanantonio: '#eaebec',
  globalIcon: '#9b9ba0',
  disabledBackground: '#d8d8d8',
  disabledFont: '#78787e',
  activeBackground: '#e1ebfc',
  globalInputDisabled: '#a9a9a9',
  globalInputSelectedBg: '#dddddd',
  yellowLine: '#f7b422',
  darkBackgroundElevation1: '#2b2b36',
  lightYellow: '#FFB44C',

  // Marianne (old)
  lightgrey: '#e4e4e4',
  darkPanelBackground: '#353541',
  darkBorder: '#595959',
  lightBorder: '#e9ecf3',
  labelPlatinum: '#fcfcfc',
  lightBackgroundBase: '#f2f2f2',
  lightBackgroundElevation2: '#ededed',
  lightLabelSecondary: '#98989a',
  darkInputText: '#42424a',
  darkInputBorder: '#cccccc',
  disabledButton: '#d1d1d6',
  darkBackgroundLightBorder: '#76808f',
  darkBackgroundBase: '#1d1d25',
  darkLinksAndButtonsActive: '#42424a',
  dropdownSelectionHover: '#a4c7ff',
  blueFormulaVariable: '#4fa6ff',

  // Solaris
  celadon: '#318483',
  steelBlue: '#4fb0c6',
  celestial: '#4f86c6',
  royal: '#6c49b8',
  orchid: '#9b51e0',
  lilac: '#bb6bd9',
  mulberry: '#d96ba0',
  tango: '#d96b6b',

  contractYellow: '#EB8705',
  contractBgYellow: '#F3EADE',
  contractWithoutOptionsBlue: '#267EFF',
  contractBgWithoutOptionsBlue: '#E9F2FF',
  batna1Green: '#339D69',
  batna1BgGreen: '#EBF5F0',
  batna2Royal: '#6427C1',
  batna2BgRoyal: '#E6E6EF',
  batna3Teal: '#298FB1',
  batna3BgTeal: '#EAF4F7',
  batna4Violet: '#FCFCFC',
  batna4BgViolet: '#EFE7FB',
  batna5Red: '#D62A1D',
  batna5BgRed: '#FBEAE8',
  batna6Brown: '#5B3311',
  batna6BgBrown: '#EFEBE7',

  tableActionRed: '#D72B3F',
  black60: 'hsla(240, 33%, 94%, 0.6)',

  modalSubTitle: '#ebebf5',
  modalDateGray: '#3c3c43',
};
